import useDealRequest, { EDealRequestType } from 'api/hooks/use-deal-request';
import { MarketTypes } from 'api/types';
import BottomSheet from 'components/bottom-sheet';
import Header from 'components/header';
import { useState } from 'react';
import { SpringEvent } from 'react-spring-bottom-sheet/dist/types';
import { toast } from 'react-toastify';
import FormRequestInSystem from 'screens/estimate/components/forms/formRequest/formRequestInSystem';
import useBoundStore from 'store';
interface IModalSubsidizingInSystemProps {
  id: number;
  isOpen: boolean;
  onSpringEnd?: (event: SpringEvent) => void;
  onDismiss: (value: boolean) => void;
  marketType: MarketTypes;
}

const TEXT =
  'Компания Reit купит вашу квартиру в минимальный срок. В дополнение к адресу укажите номер продаваемой квартиры и наши эксперты подготовят вам персональное предложение.';

const ModalRansomInSystem = ({
  id,
  isOpen,
  marketType,
  onDismiss,
  onSpringEnd,
}: IModalSubsidizingInSystemProps) => {
  const [apartmentNumber, setApartmentNumber] = useState<string>('');
  const { data: data, error, isMutating, trigger } = useDealRequest();

  const handleSubmit = async () => {
    try {
      await trigger({
        data: {
          facilityId: id,
          apartmentNumber: apartmentNumber,
        },
        type: EDealRequestType.Ransom,
        mode: 'inSystem',
        marketType: marketType,
      });
      toast.success(
        'Ваша заявка принята, наш эксперт свяжется с вами в течении 2х часов в рабочее время.',
      );
      onDismiss(false);
    } catch (error: any) {
      console.log(error);
    }
  };

  const onChangeData = (value: string) => {
    setApartmentNumber(value);
  };

  const handleDismiss = () => {
    onDismiss(false);
    setIsShowKeyBoardHeight(false);
  };

  const setIsShowKeyBoardHeight = useBoundStore((s) => s.setIsShowKeyBoardHeight);

  return (
    <BottomSheet
      initialFocusRef={false}
      open={isOpen}
      header={<Header text='Выкуп' />}
      onSpringEnd={onSpringEnd}
      onDismiss={handleDismiss}
      snapPoints={({ minHeight, maxHeight }) => maxHeight - 100}
    >
      <FormRequestInSystem
        text={TEXT}
        buttonLabel='Оставить заявку на выкуп'
        onClick={handleSubmit}
        onChange={onChangeData}
        apartmentNumber={apartmentNumber}
        isLoading={isMutating}
        onFocusInput={() => setIsShowKeyBoardHeight(true)}
        onBlurInput={() => setIsShowKeyBoardHeight(false)}
      />
    </BottomSheet>
  );
};
export default ModalRansomInSystem;
